import { render, staticRenderFns } from "./FrontierTourForm.vue?vue&type=template&id=52894189&scoped=true"
import script from "./FrontierTourForm.vue?vue&type=script&lang=js"
export * from "./FrontierTourForm.vue?vue&type=script&lang=js"
import style0 from "./FrontierTourForm.vue?vue&type=style&index=0&id=52894189&prod&lang=scss"
import style1 from "./FrontierTourForm.vue?vue&type=style&index=1&id=52894189&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52894189",
  null
  
)

export default component.exports